import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetchTeam = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [team, setTeam] = useState([]);
  const [error, setError] = useState(null);

  const sortRecords = (records) => {
    return records
      .map((record) => ({ id: record?.id, ...record?.fields }))
      .filter((member) => member?.public)
      .sort((x, y) => {
        if (x?.categories?.[0] === 'Founders') return -1;
        if (y?.categories?.[0] === 'Founders') return 1;
        return 0;
      });
  };

  useEffect(async () => {
    const url = `https://api.airtable.com/v0/appKqfi6qbh1ep0P2/team?sort%5B0%5D%5Bfield%5D=firstName&sort%5B0%5D%5Bdirection%5D=asc`;
    const records = [];
    const headers = {
      Authorization: `Bearer ${process.env.REACT_APP_AIRTABLE_PERSONAL_ACCESS_TOKEN}`
    };
    let params = {
      offset: ''
    };
    let offset = null;

    try {
      setIsLoading(true);
      const response = await axios.get(url, { params, headers });
      offset = response.data.offset;

      records.push(...response.data.records);

      while (offset !== undefined) {
        params = {
          offset
        };

        const response = await axios.get(url, { params, headers }); // eslint-disable-line no-await-in-loop

        records.push(...response.data.records);
        offset = response.data.offset;
      }

      setTeam(sortRecords(records));
      setIsLoading(false);
    } catch (error) {
      setError(error);
    }
  }, []);

  return { isLoading, team, error };
};

export default useFetchTeam;
